import { render, staticRenderFns } from "./myStroke.vue?vue&type=template&id=213dda05&scoped=true&"
import script from "./myStroke.vue?vue&type=script&lang=js&"
export * from "./myStroke.vue?vue&type=script&lang=js&"
import style0 from "./myStroke.vue?vue&type=style&index=0&id=213dda05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213dda05",
  null
  
)

export default component.exports